import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_DELETE_EVENT_MUTATION = gql`
  mutation Post(
    $id: String!,
    $eventSlugName: String!,
    ) {
    postDeleteEvent(
      id: $id,
      eventSlugName: $eventSlugName,
      ) {
      isAuth
      isDeleted
      eventSlugName
      isUsed { eventSlugNames }
    }
  }
`;

const postDeleteEvent = async ({
  id,
  eventSlugName,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_DELETE_EVENT_MUTATION,
      variables: {
        id,
        eventSlugName,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postDeleteEvent: postDeleteEventValidationData } } = result;

    if (postDeleteEventValidationData) {
      return postDeleteEventValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteEventValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteEvent Error: ${error}`);
    return null;
  }
};

export default postDeleteEvent;
